export default {
  "Mandai Rainforest Park": {
    name: "万礼热带雨林公园",
    projectType: "特色主题公园",
    developer: "",
    tenure: "",
    psf: "",
    completionYear: "2024",
    totalUnits: "",
    desc: `万礼生态雨林公园是中冶新加坡继新加坡环球影城项目之后，参与打造的新加坡另一张“旅游名片”。该园是新加坡万礼生态区的重要组成部分，也是世界首个热带雨林主题公园。该园区完工后将守护东南亚濒危珍惜野生动植物，成为亚洲自然生态教育和研究的重要枢纽，而全面完工的万礼生态区作为新加坡旅游业未来重点发展计划的国家级项目，将为新加坡的经济发展增添活力。
    万礼热带雨林公园意在打造全新的主题公园形态，作为近年广受业界关注的生态旅游项目，设计施工难点主要体现在对该区域现有生态环境的保护及可持续发展，在所有设计和施工环节中，将园区内的动植物保护放在首位，同时保证该园作为主题公园的功能性、趣味性，满足游客体验要求。`,
    website:"",
    location: {lat: 1.4063078477059157, lng: 103.7854188459452},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/mandai/rain-forest.gif')},
      {id: 1, imageSrc: require('@/assets/images/constructions/mandai/DJI_0867.gif')},
    ]
  },
  "Normanton Park": {
    name: "鑫悦府",
    projectType: "公寓",
    developer: "",
    tenure: "",
    psf: "63,685m²",
    completionYear: "2020年02月04日",
    totalUnits: "",
    desc: `鑫悦府项目合同于2018年10月04日签订，开工日期为2018年10月04日，完工日期为2022年02月04日。该项目占地面积63685平方米，总建筑面积为146900平方米，由9栋24层公寓楼和22套联排别墅组成，其中包含两层地下车库和一楼泳池景观层。`,
    website:"",
    location: {lat: 1.28804920671209, lng: 103.79291280298733},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/normanton-park/Normanton-Park-Drone-View.gif')},
      {id: 1, imageSrc: require('@/assets/images/constructions/normanton-park/normanton-park-v4-singapore-scaled.gif')},
      {id: 2, imageSrc: require('@/assets/images/constructions/normanton-park/DJI_0564.gif')},
      {id: 3, imageSrc: require('@/assets/images/constructions/normanton-park/DJI_0569.gif')},
    ]
  },
  "Changi East Depot": {
    name: "地铁跨岛线樟宜东",
    projectType: "基础工程项目",
    developer: "",
    tenure: "",
    psf: "",
    completionYear: "2030",
    totalUnits: "",
    desc: `樟宜东车辆段临近樟宜会展中心及樟宜机场，占地面积57万平方米，包括列车停车场、列车维修中心、指挥中心、后勤服务管理办公楼等配套设施。该项目预计于2030年竣工`,
    website:"",
    location: {lat: 1.3291295472060718, lng: 103.96094150912188},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/changi-east/10-6b.jpg')},
      {id: 1, imageSrc: require('@/assets/images/constructions/changi-east/10-7.jpg')},
      {id: 2, imageSrc: require('@/assets/images/constructions/changi-east/10-8.jpg')},
      {id: 3, imageSrc: require('@/assets/images/constructions/changi-east/10-9.jpg')},
      {id: 4, imageSrc: require('@/assets/images/constructions/changi-east/10-10.jpg')},
    ]
  },
  "T311 Bedok South Station": {
    name: "地铁汤申-东海岸线勿洛南站及隧道",
    projectType: "基础工程项目",
    developer: "",
    tenure: "",
    psf: "19,907.84m²",
    completionYear: "2024",
    totalUnits: "",
    desc: `
    A project worth S$188 million awarded by the Land Transport Authority (LTA) of Singapore, the Bedok South Station and Tunnels have a land area of 24,274.01 square metres, a total construction area of 19,907.84 square metres and a plot ratio of 0.82. Designed and constructed by China Jingye Engineering Corporation Limited (Singapore Branch), the Bedok South Station and Tunnels project is an underground station with tunnels spanning 270 metres. Together with Bayshore, Marine Parade, Marine Terrace, Siglap and Tanjong Rhu stations, Bedok South station will serve as the sixth Civil Defence shelter along the East Coast stretch of Thomson-East Coast Line (TEL). Works for the Bedok South Station and Tunnels commenced in 2016 with completion slated for 2025.
    The 13-kilometre East Coast stretch of the Thomson-East Coast Line (TEL) will connect commuters living in the eastern parts of Singapore and who are not directly served by the rail network currently, such as those in Tanjong Rhu, Siglap, Marine Parade, Upper East Coast and Bedok South, to the heart of the city. As part of the 43-kilometre long TEL, the East Coast stretch will also connect commuters to the Thomson stretch of the TEL, which serves the North-South Corridor. The East Coast stretch will have nine stations, including a station that interchanges with the Downtown Line at Sungei Bedok. The East Coast stretch of the TEL will be completed in two stages. The first seven stations from Tanjong Rhu to Bayshore will be ready in 2023, while the remaining two stations (Bedok South and Sungei Bedok) will be completed in 2025.
    `,
    website:"",
    location: {lat: 1.3170754472866142, lng: 103.95086916249531},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/t311/1.jpg')},
      {id: 1, imageSrc: require('@/assets/images/constructions/t311/1.jpg')}
    ]
  },
  "Jalan Papan Factory & Office": {
    name: "中冶新加坡办公综合基地及钢结构工厂",
    projectType: "公共及工业建筑项目",
    developer: "",
    tenure: "",
    psf: "6,600m²",
    completionYear: "2023",
    totalUnits: "",
    desc: `该工程占地面积6600平方米，预计于2023年完工，由办公楼及钢结构工厂两座相连的主体建筑组成。办公楼共6层，内附停车楼、内部食堂、多功能厅、顶楼花园、锦鲤池等设施，东边的裕廊河河景尽收眼底。位于二楼的内部食堂，将为在此办公的员工供应餐点，为公司各个项目的工人提供配餐服务。五楼的多功能厅，会定期举办各类员工活动。`,
    website:"",
    location: {lat: 1.3227987, lng: 103.7266427},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/jalan-papan/图片4.jpg')},
      {id: 0, imageSrc: require('@/assets/images/constructions/jalan-papan/图片2.png')},
      {id: 0, imageSrc: require('@/assets/images/constructions/jalan-papan/图片3.png')},
    ]
  },
  "Short Street Hotel": {
    name: "Short Street Hotel",
    projectType: "公共及工业建筑项目",
    developer: "",
    tenure: "",
    psf: "2,251m²",
    completionYear: "",
    totalUnits: "528",
    desc: `Short Street从肃街酒店项目占地面积2251平方米，建筑面积11160平方米，地下一层，地上十四层，共计有528间客房。该项目场地狭小，周边环境复杂，紧邻地铁线路，距离文物保护区只有5至6米，且需先拆后建，整个工期非常紧，距离最近的周边建筑物只有1米的距离，对施工场地布置和整个施工流程的管理要求很高。`,
    website:"",
    location: {lat: 1.3027459, lng: 103.8486727},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/short-street/ShortSt_trim01.gif')},
    ]
  },
}